module.exports = __webpack_public_path__ + "img/transactions.weekly.f72f50e7.png";